import { useLayoutEffect, useEffect } from 'react';
import '../utils/assertion.esm.js';
import '../utils/ssr.esm.js';
import '../utils/number.esm.js';
import '../utils/array.esm.js';
import '../utils/breakpoint.esm.js';
import '../utils/context.esm.js';
import { isBrowser } from '../utils/dom.esm.js';
import '../utils/tabbable.esm.js';
import '../utils/dom-query.esm.js';
import '../utils/logger.esm.js';
import '../utils/focus.esm.js';
import '../utils/function.esm.js';
import '../utils/keydown.esm.js';
import '../utils/lazy.esm.js';
import '../utils/object.esm.js';
import '../utils/react-helpers.esm.js';
import '../utils/style-props.esm.js';
import '../utils/tailwind.esm.js';

/**
 * useSafeLayoutEffect enables us to safely call `useLayoutEffect` on the browser
 * (for SSR reasons)
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser.
 *
 * @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 */

var useSafeLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export { useSafeLayoutEffect };
//# sourceMappingURL=use-safe-layout-effects.esm.js.map
